import { useProductBrand } from '../hooks/useProductBrand';

const ProductBrandContainer = () => {
	const { height, displayMode, blockClass, mzImage } = useProductBrand();

	return (
		<div
			className={`productBrandContainer ${blockClass ? `productBrandContainer--${blockClass} vtex-store-components-3-x-productBrandContainer--${blockClass}` : ''}vtex-store-components-3-x-productBrandContainer`}
		>
			{displayMode == 'logo' ? (
				<div
					className={`productBrandLogoWrapper ${blockClass ? `productBrandLogoWrapper--${blockClass} vtex-store-components-3-x-productBrandLogoWrapper--${blockClass}` : ''} vtex-store-components-3-x-productBrandLogoWrapper`}
					style={{ height: `${height || 100}px` }}
				>
					<img
						className={`productBrandLogo  ${blockClass ? `productBrandLogo--${blockClass} vtex-store-components-3-x-productBrandLogo--${blockClass}` : ''} vtex-store-components-3-x-productBrandLogo`}
						src={
							mzImage
								? mzImage
								: 'https://maeztraio.vtexassets.com/arquivos/ids/156857-auto-32?width=auto&height=32&aspect=true'
						}
						alt="Brand"
						style={{ height: `${height || 100}px` }}
					/>
				</div>
			) : (
				<span
					className={`productBrandName ${blockClass ? `productBrandName--${blockClass} vtex-store-components-3-x-productBrandName--${blockClass}` : ''} vtex-store-components-3-x-productBrandName`}
				>
					Tramontina
				</span>
			)}
		</div>
	);
};

export default ProductBrandContainer;
